// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  turnId: __t.u64().primaryKey().name("turn_id"),
  workspaceId: __t.u64().name("workspace_id"),
  sourceMessageId: __t.u64().name("source_message_id"),
  targetAgentId: __t.u64().name("target_agent_id"),
  seatKey: __t.string().name("seat_key"),
  requestedBy: __t.identity().name("requested_by"),
  status: __t.string(),
  lockedBy: __t.option(__t.string()).name("locked_by"),
  createdAt: __t.i64().name("created_at"),
  updatedAt: __t.i64().name("updated_at"),
  completedAt: __t.option(__t.i64()).name("completed_at"),
  error: __t.option(__t.string()),
});
